import { render, staticRenderFns } from "./MainMenuWide.vue?vue&type=template&id=650a8a17&scoped=true"
import script from "./MainMenuWide.vue?vue&type=script&lang=js"
export * from "./MainMenuWide.vue?vue&type=script&lang=js"
import style0 from "./MainMenuWide.vue?vue&type=style&index=0&id=650a8a17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a8a17",
  null
  
)

export default component.exports